module.exports = __webpack_public_path__ + "img/B_hdplan1.fc364013.png";